export default {"src":"/_next/static/media/logo.44102b7c.svg","height":56,"width":162,"blurWidth":0,"blurHeight":0};